"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestEmployeeStats = void 0;
const apollo_1 = require("@app/util/apollo");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const employeeStatsQuery = (0, graphql_tag_1.default) `
  query EmployeeStatsQuery($workspaceId: ID!, $userId: ID!, $period: PeriodInput) {
    role(workspace: $workspaceId, user: $userId) {
      employeeStats(period: $period) {
        holidayMinutes
        nightMinutes
        overTimeMinutes
        saturdayMinutes
        sundayMinutes
        workDayMinutes
        workMinutesWeekAverage
        timeOffs {
          category {
            id
            displayWorkTimeAsDays
            maxYearlyDays
            title
          }
          minutes
        }
        totalMinutes
        workMinutes
        timeOffMinutes
      }
    }
  }
`;
const requestEmployeeStats = async (variables) => {
    const { data, errors } = await (0, apollo_1.query)(employeeStatsQuery, {
        variables,
    });
    (0, error_handler_1.processErrors)(errors);
    return (0, maybe_unwrap_1.unwrapMaybe)(data?.role?.employeeStats);
};
exports.requestEmployeeStats = requestEmployeeStats;
